module.exports = __webpack_public_path__ + "img/map_chile_hospicio.e0d0ea63.png";